import React, { useState } from "react";
import { IUCNStatus } from "../common/ObjectTypes";
import { AddIcon, DeleteIcon } from "../common/ProjectIcons";
import TextInput from "../common/TextInput";

type IUCNStatusProps = {
  iucnStatuses: IUCNStatus[];
  selectedStatus: IUCNStatus;
  statusToAdd: IUCNStatus;
  addStatus: boolean;
  onSelectStatus: Function;
  onChange: Function;
  onChangeNewStatus: Function;
  onClickAdd: Function;
  onCancelEdit: Function;
  onCancelAdd: Function;
  onSaveNew: Function;
  onUpdateStatus: Function;
  onDelete: Function;
};

const IUCNStatusController = ({
  iucnStatuses,
  selectedStatus,
  statusToAdd,
  addStatus,
  onSelectStatus,
  onChange,
  onChangeNewStatus,
  onClickAdd,
  onCancelEdit,
  onCancelAdd,
  onSaveNew,
  onUpdateStatus,
  onDelete,
}: IUCNStatusProps) => {
  return (
    <div className="pt-6 bg-newGray-500 bg-opacity-50 px-6 ">
      <div className="flex flex-row justify-center">
        <div className="w-2/3">
          <h1 className="text-4xl text-center font-medium">IUCN Status</h1>

          <div className="drop-shadow-lg mt-6 bg-white bg-opacity-70 h-80 p-2 overflow-scroll">
            <table className="w-full">
              <tbody>
                {iucnStatuses.map((iucnStatus: IUCNStatus, index: number) => {
                  // Apply a different CSS class based on whether the index is odd or even
                  const rowClass =
                    index % 2 === 0 ? "bg-grayScale-400" : "bg-grayScale-200";

                  return (
                    <tr key={iucnStatus.id} className={"" + rowClass}>
                      <td className="p-2 w-full">{iucnStatus.name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IUCNStatusController;
